// extracted by mini-css-extract-plugin
var _1 = "LeJz9";
var _2 = "XycMB";
var _3 = "fUI1l";
var _4 = "EcByw";
export { _1 as "base", _2 as "dedupe", _3 as "inspectorContent", _4 as "suggestionsButton" }
